// src/components/StarCounter.js
import React from "react";
import { getTotalStars, goalStars } from "../utils/stars";
import ConstellationInlineModal from "./ConstellationInlineModal";

export default function StarCounter() {
  const [total, setTotal] = React.useState(getTotalStars());
  const [open, setOpen] = React.useState(false);
  const goal = goalStars();

  // Refresh the pill when storage changes or the window regains focus
  React.useEffect(() => {
    const refresh = () => setTotal(getTotalStars());
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Open Star Quest progress"
        title="Open Star Quest"
        style={{
          position: "fixed",
          top: 12,
          right: 12,
          zIndex: 1000,
          background: "rgba(255,255,255,0.92)",
          borderRadius: 16,
          padding: "10px 14px",
          boxShadow: "0 8px 26px rgba(0,0,0,0.12)",
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 800,
          border: "1px solid rgba(251, 191, 36, 0.65)", // soft yellow
          cursor: "pointer",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
        }}
      >
        {/* ✅ 2x bigger star */}
        <span
          style={{
            fontSize: 40, // was 20
            lineHeight: "40px",
            color: "#f59e0b",
            filter: "drop-shadow(0 2px 0 rgba(0,0,0,0.08))",
          }}
        >
          ⭐
        </span>

        <span style={{ color: "#0f172a", fontSize: 16 }}>
          {total} <span style={{ color: "#475569" }}>/ {goal}</span>
        </span>
      </button>

      {/* Constellation modal (inline, not a separate page) */}
      <ConstellationInlineModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
